var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchemaInactive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.455 4.75h13.09a1.455 1.455 0 0 1 0 2.91H5.456a1.455 1.455 0 1 1 0-2.91Zm13.09-1a2.455 2.455 0 0 1 0 4.91H5.456a2.455 2.455 0 1 1 0-4.91zm1.169 8.15a.5.5 0 0 0-.5-.5H9.928a.5.5 0 1 0 0 1h9.286a.5.5 0 0 0 .5-.5m-.5 3.357a.5.5 0 1 1 0 1H9.928a.5.5 0 0 1 0-1zm.5 4.357a.5.5 0 0 0-.5-.5H9.928a.5.5 0 1 0 0 1h9.286a.5.5 0 0 0 .5-.5M7.643 11.399a.5.5 0 1 1 0 1H4.786a.5.5 0 0 1 0-1zm.5 4.358a.5.5 0 0 0-.5-.5H4.786a.5.5 0 1 0 0 1h2.857a.5.5 0 0 0 .5-.5m-.5 3.357a.5.5 0 1 1 0 1H4.786a.5.5 0 0 1 0-1z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchemaInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schema-inactive.dc028726.svg";